import React from "react";
import {
  StyleSheet,
  View,
  Dimensions,
  ScrollView,
} from "react-native";
import TableUserRank from "../rank/tebleuserrank";
const { width, height } = Dimensions.get("window");

export default function tenUser({ data, price, setCurrentName, navigation, onOrderPress }) {
  const state = price;

  return (
    <View style={styles.container}>
      <ScrollView>
        <View style={styles.back}>
          <TableUserRank
            onOrderPress={onOrderPress}
            navigation={navigation}
            data={data}
            setCurrentName={setCurrentName}
          />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width * 0.85,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    alignItems: 'center',
    alignSelf: 'center'
  },
  viewfree: {
    width: width,
    flexDirection: "row",
    backgroundColor: "#393939",
    paddingVertical: 7,
    justifyContent: "space-between",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#fff",
    fontWeight: "bold",
    alignSelf: "center",
    marginLeft: 15,
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfil: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#000",
  },
  textfilits: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
  },
  viewfil: {
    width: width * 0.83,
    backgroundColor: "#fff",
    height: 100,
    borderRadius: 10,
    marginTop: 10,
    padding: 10,
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#fff",
    alignSelf: "center",
  },
});
